import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    qualificationData: [],
    editData: null,
    filter: {
        filterApi: true,
        form: {},
    },
    sorting: {
        column: "created_date",
        order: "DESC",
    },
};

const qualificationSlice = createSlice({
    name: "qualification",
    initialState,
    reducers: {
        setQualificationData(state, action) {
            state.qualificationData = action.payload;
        },
        setEditData(state, action) {
            state.editData = action.payload;
        },
        setQualificationFilterForm(state, action) {
            switch (action?.payload.type) {
                case "reset":
                    state.filter.form = {};
                    break;
                default:
                    state.filter.form = {
                        ...state.filter.form,
                        [action.payload.name]: action.payload.value,
                    };
            }
        },
        setQualificationSorting(state, action) {
            state.sorting = {
                column: action.payload?.column,
                order: action.payload?.order,
            };
        },
    },
});

export const {
    setQualificationData,
    setEditData,
    setQualificationFilterForm,
    setQualificationSorting,
} = qualificationSlice.actions;

export default qualificationSlice.reducer;